import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=918189ce"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports